export const en = {
  // Navigation
  schedule: 'Schedule',
  employees: 'Employees',
  vacations: 'Vacations & Absences',
  holidays: 'Holidays',
  store: 'Store',
  statistics: 'Statistics',
  export: 'Export',
  mySchedule: 'My Schedule',
  
  // Common actions
  save: 'Save',
  cancel: 'Cancel',
  delete: 'Delete',
  edit: 'Edit',
  add: 'Add',
  close: 'Close',
  back: 'Back',
  next: 'Next',
  previous: 'Previous',
  search: 'Search',
  filter: 'Filter',
  clear: 'Clear',
  confirm: 'Confirm',
  loading: 'Loading...',
  
  // Authentication
  login: 'Login',
  logout: 'Logout',
  username: 'Username',
  password: 'Password',
  loginError: 'Invalid username or password',
  scheduleSystem: 'Schedule System',
  loginWithCredentials: 'Log in with your username and password',
  loggingIn: 'Logging in...',
  testInformation: 'Test Information',
  
  // Store
  storeSelector: 'Store Selector',
  selectStore: 'Select a store',
  newStore: 'New Store',
  storeName: 'Store Name',
  address: 'Address',
  phone: 'Phone',
  email: 'Email',
  createStore: 'Create Store',
  editStore: 'Edit Store',
  deleteStore: 'Delete Store',
  storeCreated: 'Store created successfully',
  storeUpdated: 'Store updated successfully',
  storeDeleted: 'Store deleted successfully',
  storeSettings: 'Store Settings',
  weeklySchedule: 'Weekly Schedule',
  scheduleExceptions: 'Schedule Exceptions',
  addException: 'Add Exception',
  editScheduleException: 'Edit Schedule Exception',
  addScheduleException: 'Add Schedule Exception',
  updateException: 'Update Exception',
  reasonOptional: 'Reason (optional)',
  openingHours: 'Opening Hours',
  noExceptionsConfigured: 'No exceptions configured',
  date: 'Date',
  
  // Employees
  employeeName: 'Full Name',
  weeklyLimit: 'Weekly Limit (hours)',
  color: 'Employee Color',
  role: 'Employee Role',
  manager: 'Manager',
  employee: 'Employee',
  districtManager: 'District Manager',
  employeeStartDate: 'Start Date',
  birthday: 'Date of Birth',
  vacationDays: 'Vacation Days per Year',
  unavailableTimes: 'Unavailable Times',
  addEmployee: 'Add Employee',
  editEmployee: 'Edit Employee',
  deleteEmployee: 'Delete Employee',
  employeeCreated: 'Employee created successfully',
  employeeUpdated: 'Employee updated successfully',
  employeeDeleted: 'Employee deleted successfully',
  newEmployee: 'New Employee',
  regularEmployee: 'Regular Employee',
  mainManager: 'Main Manager',
  uniqueUsernameForLogin: 'Unique username for employee login',
  passwordForLogin: 'Password for employee login',
  employeeList: 'Employee List',
  active: 'Active',
  inactive: 'Inactive',
  create: 'Create',
  update: 'Update',
  manageEmployeeInfo: 'Manage your employees\' information',
  
  // Schedule
  week: 'Week',
  month: 'Month',
  day: 'Day',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
  startTime: 'Start Time',
  endTime: 'End Time',
  hours: 'Hours',
  duration: 'Duration',
  published: 'Publish',
  draft: 'Draft',
  addShift: 'Create Shifts',
  editShift: 'Edit Shift',
  deleteShift: 'Delete Shift',
  copyWeek: 'Copy Week',
  repeatWeek: 'Repeat',
  deleteWeek: 'Delete Week',
  compactMode: 'Compact Mode',
  normalMode: 'Normal Mode',
  thisWeek: 'This Week',
  copying: 'Copying...',
  clickEmployeeToCreateShift: 'Click on an employee to create a shift manually',
  view24h: 'View 24h',
  
  // Absences
  absenceManagement: 'Absence Management',
  absenceType: 'Absence Type',
  vacation: 'Vacation',
  sick: 'Sick Leave',
  personal: 'Personal',
  other: 'Other',
  absenceStartDate: 'Start Date',
  absenceEndDate: 'End Date',
  reason: 'Reason',
  status: 'Status',
  pending: 'Pending',
  approved: 'Approved',
  rejected: 'Rejected',
  newRequest: 'New Request',
  requestSubmitted: 'Request submitted successfully',
  remainingVacationDays: 'Remaining Vacation Days',
  type: 'Type',
  dates: 'Dates',
  days: 'Days',
  actions: 'Actions',
  absenceTypeLabel: 'Absence Type',
  startDate: 'Start Date',
  endDate: 'End Date',
  employeeInfo: 'Employee Information',
  requestDate: 'Request Date',
  approvedBy: 'Approved by:',
  rejectedBy: 'Rejected by:',
  rejectionReason: 'Rejection reason:',
  manageAllAbsenceRequests: 'Manage all absence requests',
  totalAbsences: 'Total Absences',
  allTypes: 'All types',
  allStatuses: 'All states',
  allEmployees: 'All employees',
  requestDetails: 'Request Details',
  name: 'Name',
  absenceInformation: 'Absence Information',
  scheduleRestrictions: 'Schedule restrictions',
  shiftPendingPublication: 'shift pending publication',
  shiftsPendingPublication: 'shifts pending publication',
  defineOpeningHoursAndExceptions: 'Define opening hours and exceptions',
  open: 'Open',
  closed: 'Closed',
  opens: 'Opens',
  closes: 'Closes',
  range: 'Range',
  addRange: 'Add range',
  addAnotherRange: 'Add another range',
  lastSynchronization: 'Last synchronization',
  holidayInformation: 'Holiday Information',
  nationalHolidaysSyncAutomatically: 'National holidays are automatically synchronized each year. These days are automatically considered non-working days in schedule planning.',
  
  // Statistics
  coverageAndWorkloadMetrics: 'Coverage and workload metrics',
  activeEmployees: 'Active Employees',
  shiftsThisWeek: 'Shifts This Week',
  totalHours: 'Total Hours',
  statisticsByEmployee: 'Statistics by Employee',
  assignedHours: 'Assigned Hours',
  weeklyCap: 'Weekly Cap',
  utilization: '% Utilization',
  busiestDay: 'Busiest Day',
  daysWithoutWeekend: 'Days Without Weekend',
  
  // Export
  exportSchedules: 'Export Schedules',
  exportPublishedSchedulesInDifferentFormats: 'Export published schedules in different formats',
  ical: 'iCal',
  google: 'Google',
  noPublishedSchedulesToExport: 'No published schedules to export',
  
  // Additional UI elements
  newAbsenceRequest: 'New Absence Request',
  selectEmployee: 'Select employee',
  describeAbsenceReason: 'Describe the reason for the absence...',
  submitting: 'Submitting...',
  submitRequest: 'Submit Request',
  vacationsAndAbsences: 'Vacations and Absences',
  requestVacation: 'Request Vacation',
  newVacationRequest: 'New Vacation Request',
  myVacationRequests: 'My Vacation Requests',
  clickRequestVacationToCreateFirstRequest: 'Click "Request Vacation" to create your first request',
  vacationManagement: 'Vacation Management',
  vacationRequests: 'Vacation Requests',
  
  // Absence Types
  sickness: 'Sick Leave',
  unjustified: 'Unjustified Absence',
  special: 'Special Leave',
  
  // Holidays
  holidayName: 'Holiday Name',
  holidayDate: 'Holiday Date',
  addHoliday: 'Add',
  editHoliday: 'Edit Holiday',
  automaticHolidayManagement: 'Automatic management of national holidays',
  addCustomHoliday: 'Add Custom Holiday',
  editCustomHoliday: 'Edit Custom Holiday',
  updateHoliday: 'Update Holiday',
  nationalHolidays: 'National Holidays',
  loadingHolidays: 'Loading holidays...',
  deleteHoliday: 'Delete Holiday',
  
  // Statistics
  totalEmployees: 'Total Employees',
  totalShifts: 'Total Shifts',
  averageHours: 'Average Hours',
  coverageProblems: 'Coverage Problems',
  noProblems: 'No coverage problems detected',
  gap: 'Gap',
  conflict: 'Conflict',
  overtime: 'Overtime',
  emptyDay: 'No shifts',
  weeklyOvertime: 'Weekly overtime',
  storeClosed: 'Store closed',
  
  // Export
  exportData: 'Export Data',
  selectDateRange: 'Select Date Range',
  from: 'From',
  to: 'To',
  exportFormat: 'Export Format',
  excel: 'Excel',
  csv: 'CSV',
  exportSuccess: 'Data exported successfully',
  
  // Configuration
  configuration: 'Configuration',
  language: 'Application Language',
  country: 'Country (for holidays)',

  // Header
  scheduleAdministrationPanel: 'Schedule Administration Panel',
  welcome: 'Welcome',
  invalidDay: 'Invalid day',

  // Keyboard Shortcuts
  keyboardShortcuts: 'Keyboard Shortcuts',
  showHideShortcutsHelp: 'Show/hide shortcuts help',
  toggleDarkMode: 'Toggle dark mode',
  closeModalsAndPanels: 'Close modals and panels',
  openNotificationCenter: 'Open notification center',
  goToScheduleTab: 'Go to Schedule tab',
  goToEmployeesTab: 'Go to Employees tab',
  goToConfigurationTab: 'Go to Configuration tab',
  goToStatisticsTab: 'Go to Statistics tab',
  goToExportTab: 'Go to Export tab',
  createNewShift: 'Create new shift',
  saveSchedules: 'Save schedules',
  publishSchedules: 'Publish schedules',
  navigateBetweenWeeks: 'Navigate between weeks',
  zoomInOut: 'Zoom in/out',
  resetZoom: 'Reset zoom',
  addNewEmployee: 'Add new employee',
  searchEmployees: 'Search employees',
  saveEmployee: 'Save employee',
  cancelEdit: 'Cancel edit',
  refreshStatistics: 'Refresh statistics',
  exportStatistics: 'Export statistics',
  refreshSchedules: 'Refresh schedules',
  pressCtrlSlashToShowHideHelp: 'Press Ctrl + / to show/hide this help',

  // Keyboard Shortcut Categories
  general: 'General',
  navigation: 'Navigation',
  schedules: 'Schedules',

  // Coverage Problems
  gapWithoutCoverage: 'Gap without coverage of',
  excessiveWorkday: 'Excessive workday',
  noShifts: 'No shifts',
  excessiveWeeklyHours: 'Excessive weekly hours',
  problem: 'Problem',
  
  // Notifications
  notifications: 'Notifications',
  noNotifications: 'No notifications',
  markAllAsRead: 'Mark all as read',
  markAsRead: 'Mark as read',
  justNow: 'Just now',
  hoursAgo: 'h ago',
  yesterday: 'Yesterday',
  birthdayToday: 'Birthday today',
  reviewAssignments: 'Review assignments',
  verifyAllEmployeesHaveAssignedSchedules: 'Verify that all employees have assigned schedules',
  notification: 'notification',
  
  // Errors
  error: 'Error',
  success: 'Success',
  warning: 'Warning',
  info: 'Information',
  required: 'This field is required',
  invalidDate: 'Invalid date',
  invalidTime: 'Invalid time',
  networkError: 'Network error. Please try again.',
  
  // Confirmations
  confirmDelete: 'Are you sure you want to delete this item?',
  confirmDeleteWeek: 'Are you sure you want to delete all shifts for this week? This action cannot be undone.',
  confirmDeleteAll: 'Are you sure you want to delete ALL data? This action will delete all stores, employees and shifts. This action cannot be undone.',
  
  // Time formats
  timeFormat: 'HH:MM',
  defaultDateFormat: 'DD/MM/YYYY',
  
  // Days of week
  daysOfWeek: {
    monday: 'Mon',
    tuesday: 'Tue',
    wednesday: 'Wed',
    thursday: 'Thu',
    friday: 'Fri',
    saturday: 'Sat',
    sunday: 'Sun'
  },

  // Store Management
  storeManagement: 'Store Management',
  welcomeSelectStore: 'Welcome, {name}. Select a store to manage or create a new one.',
  activeStores: 'Active Stores',
  storeList: 'Store List',
  generateTestData: 'Generate Test Data',
  noStoresYet: 'No stores created yet',
  createFirstStore: 'Create your first store to start managing schedules and employees.',
  storeAddress: 'Address',
  storePhone: 'Phone',
  storeEmail: 'Email',
  storeNamePlaceholder: 'Ex: Central Store',
  storeAddressPlaceholder: 'Ex: Main Street 123',
  storePhonePlaceholder: 'Ex: +1 123 456 789',
  storeEmailPlaceholder: 'Ex: store@company.com',
  editStoreTitle: 'Edit Store',
  createStoreTitle: 'Create New Store',
  storeNameRequired: 'Store name is required',
  confirmDeleteStore: 'Are you sure you want to delete the store "{storeName}"? This action cannot be undone.',
  shifts: 'Shifts',
  manageStore: 'Manage Store',

  // Date Format
  dateFormat: 'Date Format',
  dateFormatDDMMYYYY: 'DD/MM/YYYY',
  dateFormatMMDDYYYY: 'MM/DD/YYYY',
  dateFormatYYYYMMDD: 'YYYY/MM/DD',

  // Employee Dashboard
  mySchedules: 'My Schedules',
  welcomeEmployee: 'Welcome, {name}',
  previousWeek: 'Previous Week',
  nextWeek: 'Next Week',
  thisMonth: 'This Month',
  myShifts: 'My Shifts',
  shiftCalendar: 'Shift Calendar',
  list: 'List',
  calendar: 'Calendar',
  noShiftsThisWeek: 'You have no shifts assigned this week',
  noShiftsThisMonth: 'You have no shifts assigned this month',
  previousMonth: 'Previous Month',
  nextMonth: 'Next Month',
  closeSession: 'Logout',

  // Time Clock
  timeClock: 'Time Clock',
  clockIn: 'Clock In',
  clockOut: 'Clock Out',
  lastAction: 'Last action',
  entry: 'Entry',
  exit: 'Exit',
  gettingLocation: 'Getting location...',
  locationPermissionDenied: 'Location permission denied. Please allow location access in your browser settings.',
  locationUnavailable: 'Could not get location. Make sure GPS is enabled.',
  locationTimeout: 'Timeout while getting location.',
  tooFarFromStore: 'You are too far from the store ({distance}m). Maximum allowed distance: {maxDistance}m',
  noShiftsOrEntries: 'No shifts or entries'
};
